import { useApi, apiResolver, useCustomApi } from "@/api/useApi";
import { useMemo } from "react";
import {
  ApprovalRequest,
  GetApprovalRequestsResponse,
  ApprovalRequestStatus,
  ApprovalRequestPriority,
} from "./ApprovalRequest.model";
import {
  HumanAssistRequest,
  HumanAssistRequestStatus,
  GetHumanAssistRequestsResponse,
} from "./HumanAssistRequest.model";

export type GetApprovalRequestsParams = {
  status?: ApprovalRequestStatus;
  priority?: ApprovalRequestPriority;
  limit?: number;
  offset?: number;
};

export type GetHumanAssistRequestsParams = {
  status?: HumanAssistRequestStatus;
  ticketId?: string;
  limit?: number;
  offset?: number;
};

export function useApprovalRequestApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      // Approval Request methods
      getApprovalRequests: (params?: GetApprovalRequestsParams) =>
        apiResolver<GetApprovalRequestsResponse>(
          api.get(`/platform/approval-requests`, { params })
        ),
      getApprovalRequest: (id: string) =>
        apiResolver<ApprovalRequest>(
          api.get(`/platform/approval-requests/${id}`)
        ),
      approveRequest: (id: string) =>
        apiResolver<ApprovalRequest>(
          api.post(`/platform/approval-requests/${id}/approve`)
        ),
      rejectRequest: (id: string, reason?: string) =>
        apiResolver<ApprovalRequest>(
          api.post(`/platform/approval-requests/${id}/reject`, { reason })
        ),

      // Human Assist Request methods
      getHumanAssistRequests: (params?: GetHumanAssistRequestsParams) =>
        apiResolver<GetHumanAssistRequestsResponse>(
          api.get(`/platform/human-assist-requests`, { params })
        ),
      getHumanAssistRequest: (id: string) =>
        apiResolver<HumanAssistRequest>(
          api.get(`/platform/human-assist-requests/${id}`)
        ),
      answerAssistRequest: (inngestRequestId: string, answer: string) =>
        apiResolver<HumanAssistRequest>(
          api.post(`/platform/human-assist-requests/${inngestRequestId}/answer`, { answer })
        ),
    }),
    [api]
  );
}
